import { Component, OnInit, ViewChild, ChangeDetectorRef, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { HelperService } from '../common/helper.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Globals } from '../common/Globals';
import { AuthService } from '../login/auth.service';
import { tap, finalize, take, map, first } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DriverModel } from '../common/models/dashboard.models';
import { HeaderModel, DriverTableRecord } from '../common/models/header.models';
import * as moment from 'moment';
import { FuelBid } from '../common/models/fuel-bid.models';

// import {setInterval, clearInterval} from
declare var google: any;
declare var am4core: any;
declare var $: any;
const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DashboardComponent implements OnInit {
  loggedUser: string;
  userDevices: any[];
  selectedDevice: any;
  lat: number = 0;
  lng: number = 0;
  centerLat: number = 39.381266;
  centerLng: number = -97.922211;
  filter: string = '';
  userDevicesFiltered: any[];
  sortExpression = null;
  deviceMapId = '';
  mapDevicesFiltered: any[];
  showCenter: boolean = true;
  map: any;
  selectedDeviceId = '';
  filterValue = null;
  filterByGroup = null;
  usedGraphName = '';
  changingNameId = '';
  changingTankNameId = '';
  sortId = '';
  filterId = '';
  showDatePicker = false;
  showAlarmInfoBox = false;
  csvStart = '';
  csvEnd = '';
  chartTimeStart = '';
  chartTimeEnd = '';
  showCoordinatesDialog = false;
  updateDeviceData = null;
  devicePsi = null;
  selectedDeviceForEdit = null;
  selectedDeviceForEditId = null;
  timezones = [];
  templates: any = [];
  justUnusedTemplateModel = '0';
  password = '';
  isMobile = false;
  title = 'Dashboard';
  showFilter = false;
  showSort = false;
  showSingleView = false;
  showMapView = false;
  refreshTimeInterval = Globals.refreshTime * 1000;
  mapDeviceShown = false;
  showSortChart = false;
  boxSize = parseInt(localStorage.getItem('getBoxSize'));

  groupChangeActionTitle = 'Start';
  maxNumberOfBoxes = 5;
  animationSpeed = 100;
  groupChangeTime = parseInt(localStorage.getItem('getChangeGroupTime'));
  maxTimeOfGroupChange = 500;
  animationSpeedIndicator = 1;
  maxAnimationSpeed = 20;
  animationCommand = 'start';
  animateSerie;
  scrollListTop;
  selectedGSM;
  selectedGSMId;
  showChartDatePicker = false;
  showDescriptionEdit = false;
  autoRefreshInterval;
  isFirstChecked = false;
  isSecondChecked = false;

  bid = localStorage.getItem('bid') == "1";


  chanels = ['AD0', 'AD1', 'AD2', 'AD3', 'AD4', 'AD5', 'AD6', 'AD7', 'AD8', 'AD9'];
  tanks = ['none', 'cm / gallons', 'cm / liters', 'inches / gallons', 'inches / liters'];
  groups = [{ value: "1", viewValue: "group1" }, { value: "2", viewValue: "group2" }, { value: "3", viewValue: "group3" }, { value: "4", viewValue: "group4" }, { value: "5", viewValue: "group5" },
  { value: "6", viewValue: "group6" }, { value: "7", viewValue: "group7" }, { value: "8", viewValue: "group8" }, { value: "9", viewValue: "group9" }, { value: "10", viewValue: "group10" }]



  constructor(private dashboardService: DashboardService,
    private helperService: HelperService,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private authService: AuthService,
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef) {
    let temp = new Date();
    const month = temp.getMonth() + 1;
    this.csvStart = '' + temp.getFullYear() + '-' + (month < 10 ? ('0' + month) : month) + '-01T00:00';
    this.csvEnd = '' + temp.getFullYear() + '-' + (month < 10 ? ('0' + month) : month) + '-30T23:59';



    var days = -7;
    var date = new Date();
    var res = date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    date = new Date(res);
    this.chartTimeStart = '' + date.toISOString().slice(0, 10);

    var end_date = new Date();
    this.chartTimeEnd = '' + end_date.toISOString().slice(0, 10);

    /*
          https://www.tutorialspoint.com/tpcg.php?p=7SLDc7
    */
  }

  /*
  onSortModal() {
    let findActiveGroup = document.getElementsByClassName("active");
    if (findActiveGroup.length !== 0) {
      this.showSortedGroup(parseInt(findActiveGroup.item(0).id.substring(5)));
    }
    else {
      this.showSortedGroup(1);
    }
    $('#sortmodal').modal('show');
  }
  */


  refreshDashboard = function () {
    this.ngxService.start();
    this.refreshView();
    this.selectFirstDevice();
  }

  ngOnInit() {

    this.authService.checkValidation();

    console.log(parseInt(localStorage.getItem('groupChangeTime')));

    this.generateTimezoneModel();
    this.isMobile = this.helperService.isMobile;
    this.loggedUser = this.helperService.loggedUsername;
    this.refreshDashboard();
    this.boxSize = parseInt(localStorage.getItem('getBoxSize'));

    $('#passwordmodal').on('shown.bs.modal', function () {
      $('#password').focus()
    });

    $('#passwordmodalxx').on('shown.bs.modal', function () {
      $('#passwordxx').focus()
    });

    $('#sortmodal').on('shown.bs.modal', () => {
      console.log('sort modal shown');
      this.autoRefreshInterval = setInterval(() => {
        this.refreshDashboard();
      }, this.refreshTimeInterval * 60)
    });

    $('#sortmodal').on('hidden.bs.modal', () => {
      $('#sortDeviceTable').stop();
      $('#sortDeviceTable').finish();
      clearTimeout(this.scrollListTop);
      clearInterval(this.animateSerie);
      clearInterval(this.autoRefreshInterval);
      this.animationCommand = 'start';
    });
    $('.sort-group-menu-item').on('click', function () {
      if (!$(this).hasClass('active')) {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
      }
    });
  }


  boxSizeControl(arithCommand: string) {
    if (this.boxSize > 0 && this.boxSize <= this.maxNumberOfBoxes) {
      if (arithCommand === 'add') {
        if (this.boxSize < this.maxNumberOfBoxes) {
          this.boxSize++;
        }
      } else if (arithCommand === 'substract') {
        if (this.boxSize > 1) {
          this.boxSize--;
        }
      }
    }
  }

  boxChangeGroupControl(arithCommand: string) {
    if (this.groupChangeTime > 0 && this.groupChangeTime <= this.maxTimeOfGroupChange) {
      if (arithCommand === 'add') {
        if (this.groupChangeTime < this.maxTimeOfGroupChange) {
          this.groupChangeTime = this.groupChangeTime + 10;
          localStorage.setItem('groupChangeTime', this.groupChangeTime.toString());
        }
      } else if (arithCommand === 'substract') {
        if (this.groupChangeTime > 10) {
          this.groupChangeTime = this.groupChangeTime - 10;
        }
      }
    }
  }


  boxSpeedControl(arithCommand: string) {
    //console.log()
    //if(this.animationSpeed > 0 && this.animationSpeed <= this.maxAnimationSpeed) {
    if (arithCommand === 'add') {
      //if (this.animationSpeed < this.maxAnimationSpeed) {
      this.animationSpeed++;
      this.animationSpeedIndicator--;
      //}
    } else if (arithCommand === 'substract') {
      if (this.animationSpeed > 1) {
        this.animationSpeed--;
        this.animationSpeedIndicator++;
      }
    }
    // }

    console.log(this.animationSpeed);
  }

  boxListAnimation() {
    //setTimeout(function(){window.location.hash = '#second';},5000);

    var deviceTableList = document.getElementById("sortDeviceTable");
    var animationSpeed = this.animationSpeed * deviceTableList.scrollHeight;

    function scrollList() {
      $(deviceTableList).animate({ scrollTop: deviceTableList.scrollHeight }, (animationSpeed));
      $(deviceTableList).animate({ scrollTop: 0 }, (animationSpeed));
    }

    if (this.animationCommand === 'start') {
      $(deviceTableList).animate({ scrollTop: deviceTableList.scrollHeight }, (animationSpeed));
      this.scrollListTop = setTimeout(function () {
        $(deviceTableList).animate({ scrollTop: 0 }, (animationSpeed));
      }, animationSpeed);
      this.animateSerie = setInterval(scrollList, animationSpeed);
      this.animationCommand = 'stop';
    } else if (this.animationCommand === 'stop') {
      $(deviceTableList).stop();
      $(deviceTableList).finish();
      clearTimeout(this.scrollListTop);
      clearInterval(this.animateSerie);
      this.animationCommand = 'start';
    }
  }

  selectFirstDevice() {
    if (!this.isMobile) {
      var sub = this.dashboardService.getUserDevices('null', 'null', 'null').subscribe((response: any) => {
        this.userDevicesFiltered = response;
        this.userDevices = response;
        let firstDevice = this.userDevicesFiltered[0];
        this.selectDevice(firstDevice);
        this.selectedGSM = firstDevice.gsmId;
        sub.unsubscribe();
        this.ngxService.stop();
      });
    }
    else {
      var sub = this.dashboardService.getUserDevices('null', 'null', 'null').subscribe((response: any) => {
        this.userDevicesFiltered = response;
        this.userDevices = response;
        sub.unsubscribe();
        this.ngxService.stop();
      });
    }
  }

  refreshGroups(){
    this.ngxService.start();
      var sub = this.dashboardService.getUserDevices('null', 'null', 'null').subscribe((response: any) => {
        this.userDevicesFiltered = response.filter(x => x.deviceGroup == this.filterByGroup);
        let firstDevice = this.userDevicesFiltered[0];
        this.selectDevice(firstDevice);
        this.selectedGSM = firstDevice.gsmId;
        sub.unsubscribe();
        this.ngxService.stop();
      });
  }

  selectSortDevice(device: any) {
    this.selectedDevice = device;
    if (this.selectedDeviceId === device.gsmId) {
      // this.showSortChart = true;
    }
    this.usedGraphName = '';
    this.selectedDeviceId = device.gsmId;
    this.selectedGSM = device.gsmId;
    // this.showSortChart = true;
    if (this.showSortChart === true) {
      console.log('jep')
      this.getSortGraphData('a01');
    }
  }

  selectDevice(device: any) {
    if (device != null) {
      this.selectedDevice = device;
      if (this.isMobile) {
        this.title = 'Data';
        this.showSingleView = true;
      }
      if (this.selectedDeviceId === device.gsmId) {
        return;
      }
      this.usedGraphName = '';
      this.selectedDeviceId = device.gsmId;
      this.selectedGSM = device.gsmId;
      if (this.deviceMapId) {
        (<any>document.getElementById(this.deviceMapId)).checked = false;
      }
      this.mapDevicesFiltered = null;
      if (this.selectedDevice.latitude === null || this.selectedDevice.longitude === null) {
        this.showCenter = true;
      } else {
        this.lat = +this.selectedDevice.latitude;
        this.lng = +this.selectedDevice.longitude;
        this.showCenter = false;
      }
      this.getGraphData('a01');
    }
    else {
      this.selectedDevice = null;
      this.selectedDeviceId = "";
      this.selectedGSM = "";
    }
  }

  applyTableControls() {
      this.userDevicesFiltered = this.userDevices.filter(x => x.gsmName.toLowerCase().includes(this.filter.toLowerCase()) || x.gsmId.toLowerCase().includes(this.filter.toLowerCase()));
      if (this.filterValue) {
        const expression = this.filterValue === 'red' ? x => x.colorDevice === 'red' || x.colorDevice === 'orange' :
          x => x.colorDevice === this.filterValue;
        this.userDevicesFiltered = this.userDevicesFiltered.filter(expression);
      }
      if (this.sortExpression) {
        this.userDevicesFiltered = this.userDevicesFiltered.sort(this.sortExpression);
      }
      if (this.filterByGroup)
        this.userDevicesFiltered = this.userDevicesFiltered.filter(x => x.deviceGroup == this.filterByGroup);
        
  }

  closeSortModal() {
    this.userDevicesFiltered = this.userDevices;
    $('#sortmodal').modal('hide');
  }
  logout() {
    localStorage.setItem('gesAuthToken', null);
    localStorage.setItem('gesActiveUser', null);
    localStorage.setItem('rememberMe', "false");
    localStorage.setItem('loginTime', null);
    localStorage.setItem('bid', null);
    this.router.navigate(['/login']);
  }

  onSearch(event: any) {
    this.usedGraphName = '';
    this.selectedDeviceId = '';
    this.selectedDevice = null;
    this.filter = event.target.value;
    this.applyTableControls();
  }

  onDeviceMapChange() {
    this.mapDevicesFiltered = this.userDevices.filter(x => +x.latitude && +x.longitude)
      .map(x => {
        return {
          lat: +x.latitude, lng: +x.longitude, gsmName: x.gsmName, gsmId: x.gsmId,
          colorDevice: x.colorDevice, uploadtimeLocal: x.uploadtimeLocal,
          capacityA01Max: x.capacityA01Max,
          capacityA02Max: x.capacityA02Max,
          capacityA03Max: x.capacityA03Max,
          capacityA04Max: x.capacityA04Max,
          valueA01: x.valueA01,
          valueA02: x.valueA02,
          valueA03: x.valueA03,
          valueA04: x.valueA04,
          colorA01: x.colorA01,
          colorA02: x.colorA02,
          colorA03: x.colorA03,
          colorA04: x.colorA04,
          ullageA01: x.ullageA01,
          ullageA02: x.ullageA02,
          ullageA03: x.ullageA03,
          ullageA04: x.ullageA04,
          a01Name: x.a01Name,
          a02Name: x.a02Name,
          a03Name: x.a03Name,
          a04Name: x.a04Name,
        }
      });
    this.showCenter = this.mapDevicesFiltered.length === 0;

    /*
     $('[agm-map-holder="map_go_fullscreen"]').click(function(e){
       var map = document.querySelector(".gm-style");
       map.requestFullscreen();
     });
    */

    setTimeout(() => {
      document.querySelector(".gm-style").requestFullscreen();
    }, 2000);
  }



  afterClose(event: any) {
    console.log('closed')
  }

  onMapReady(event: any) {
    this.map = event;
    let bounds = new google.maps.LatLngBounds();
    for (let i in this.mapDevicesFiltered) {
      const marker = this.mapDevicesFiltered[i];
      bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
    }
    this.map.fitBounds(bounds);
    //this.map.requestFullScreen=true;
  }

  getMapDeviceStatus() {
    if (this.mapDeviceShown === false) {
      this.mapDeviceShown = true;
    } else {
      this.mapDeviceShown = false;
    }
  }

  onFilter(event: any) {
    this.filterId = event.target.id;
    if (event.target.value === 'all') {
      this.filterValue = null;
      this.userDevicesFiltered = [].concat(this.userDevices);
    } else {
      this.usedGraphName = '';
      this.selectedDeviceId = '';
      this.selectedDevice = null;
      this.filterValue = event.target.value;
      const expression = event.target.value === 'red' ? x => x.colorDevice === 'red' || x.colorDevice === 'orange' :
        x => x.colorDevice === event.target.value;
      this.userDevicesFiltered = this.userDevices.filter(expression);
    }
    if (this.sortExpression) {
      this.userDevicesFiltered = this.userDevicesFiltered.sort(this.sortExpression);
    }
  }

  onSort(event: any) {
    if (event.target.value === '1') {
      this.sortExpression = (a, b) => {
        if (a.gsmName.toLowerCase() > b.gsmName.toLowerCase()) {
          return 1;
        } else if (b.gsmName.toLowerCase() > a.gsmName.toLowerCase()) {
          return -1;
        } else {
          return 0;
        }
      }
    } else if (event.target.value === '2') {
      this.sortExpression = (a, b) => {
        if (a.gsmName.toLowerCase() < b.gsmName.toLowerCase()) {
          return 1;
        } else if (b.gsmName.toLowerCase() < a.gsmName.toLowerCase()) {
          return -1;
        } else {
          return 0;
        }
      }
    } else if (event.target.value === '3') {
      this.sortExpression = (a, b) => {
        if (a.gsmId > b.gsmId) {
          return 1;
        } else if (b.gsmId > a.gsmId) {
          return -1;
        } else {
          return 0;
        }
      }
    } else {
      this.sortExpression = (a, b) => {
        if (a.gsmId < b.gsmId) {
          return 1;
        } else if (b.gsmId < a.gsmId) {
          return -1;
        } else {
          return 0;
        }
      }
    }
    this.sortId = event.target.id;
    this.applyTableControls();
  }
  refreshView() {

    // this.filter = '';
    // this.filterValue = '';
    // this.sortExpression = null;
    this.mapDevicesFiltered = null;
    this.showCenter = true;
    this.usedGraphName = '';
    this.selectedDeviceId = '';
    this.selectedDevice = null;
    this.changingTankNameId = '';
    this.changingNameId = '';
    // this.sortId = '';
    // this.filterId = '';
    this.updateDeviceData = null;
    this.selectedDeviceForEdit = null;
    this.selectedDeviceForEditId = '';
    this.templates = [];
    this.justUnusedTemplateModel = '0';

    const deviceTable = document.getElementById('device-table');
    if (deviceTable) {
      deviceTable.scrollTop = 0;
    }
    if (this.deviceMapId) {
      (<any>document.getElementById(this.deviceMapId)).checked = false;
      this.deviceMapId = '';
    }
    let sort = document.getElementById('sortChoice3');
    if (sort) {
      (<any>sort).checked = true;;
    }
    // let activeGroup = document.getElementsByClassName('active').item(0);

    // if (activeGroup)
    // {
    //   this.filterByGroup = activeGroup.id.substring(5);

    //   // TRIGGER GROUP 1 onClick
    //   setTimeout(function () {  
    //     document.getElementById("group1").click();
    //   }, 5000);
    // }
  }

  changeDeviceName(device: any) {
    this.dashboardService.updateDeviceName(device.gsmId, device.gsmName).subscribe(() => {
      this.changingNameId = '';
    })
  }

  changeTankName(device: any, tank: string) {
    this.dashboardService.updateTankName(device.gsmId, 'a0' + tank, device['a0' + tank + 'Name']).subscribe(() => {
      this.changingTankNameId = '';
      // device['a0' + tank + 'Name'] = 'A0' + tank + ' - ' + device['a0' + tank + 'Name'];
    })
  }


  changeDeviceSort() {
    var deviceTitleId;
    // Generate deviceIDlis
    var deviceList = '';
    $('.sort-device-table .table-sort-item').each(function (i) {
      deviceTitleId = $(this).find('.device-title-holder .device-title-id').text();
      var idIndex = i + 1;
      //deviceList += ('<id>'+idIndex+':'+$.trim(deviceTitleId)+'</id>');
      deviceList += ('' + idIndex + ':' + $.trim(deviceTitleId) + ';');
    });
    //deviceList += ('</result>"');

    console.log(this.loggedUser + ', ' + deviceList + ', ' + this.boxSize);
    console.log('AAAA');
    localStorage.setItem('getBoxSize', this.boxSize.toString());
    localStorage.setItem('getChangeGroupTime', this.groupChangeTime.toString());

    this.dashboardService.updateDeviceSort(this.loggedUser, deviceList, this.boxSize, this.groupChangeTime).subscribe(() => {
    })
  }

  changeGroupInterval;
  startChangeGroupOnTimer() {
    let index = 1;
    if (this.groupChangeActionTitle == "Start") {
      this.groupChangeActionTitle = "Stop";
      this.changeGroupInterval = setInterval(() => {
        if (!this.checkIsGroupEmpty(index)) {
          this.showSortedGroup(index);
        }
        else {
          var firstFullGroup = this.findFirstFullGroup(index);
          this.showSortedGroup(firstFullGroup);
          index = firstFullGroup;
        }
        index++;
        if (index > 10) {
          index = 1;
        }
      }, this.groupChangeTime * 1000)
    }
    else {
      clearInterval(this.changeGroupInterval);
      this.groupChangeActionTitle = "Start";
    }

  }

  findFirstFullGroup(currentGroup: number) {
    let searchpar = currentGroup;
    for (let i = 0; i < 10; i++) {
      if (searchpar > 10)
        searchpar = 0;
      console.log(this.userDevices.filter(x => x.deviceGroup == searchpar.toString()).length)
      if (this.userDevices.filter(x => x.deviceGroup == searchpar.toString()).length != 0)
        return searchpar;

      searchpar = searchpar + 1
    }
  }
  checkIsGroupEmpty(groupId: number): boolean {
    var devices = this.userDevices.filter(x => x.deviceGroup == groupId);
    return devices.length == 0;
  }

  setNameForEdit(number: any) {
    if (!this.selectedDevice) {
      return;
    }
    this.changingTankNameId = 'a0' + number;
    this.selectedDevice['a0' + number + 'Name'] = this.selectedDevice['a0' + number + 'Name'].replace('A0' + number + ' -', '');
  }

  getGraphData(tankName: string) {

    /*
       if (!this.selectedDevice) {
         console.log("A");
         return;
       }
       if (this.usedGraphName === tankName) {
         console.log("B");
         return;
       }
   */
    this.usedGraphName = tankName;
    let currentTankName = tankName.toUpperCase();
    let capacityMax = this.selectedDevice['capacity' + currentTankName + 'Max'];

    this.dashboardService.getGraph(this.selectedDeviceId, tankName, this.chartTimeStart, this.chartTimeEnd).subscribe((response: any) => {
      if (response) {
        this.initChart(response.graph_data, response.min, response.max, capacityMax);
      } else {
        this.initChart({}, 0, 0, 0);
      }
    });
  }

  getSortGraphData(tankName: string) {
    // if (!this.selectedDevice) {
    //   return;
    // }
    // if (this.usedGraphName === tankName) {
    //   return;
    // }
    this.usedGraphName = tankName;
    let currentTankName = tankName.toUpperCase();
    let capacityMax = this.selectedDevice['capacity' + currentTankName + 'Max'];

    this.dashboardService.getGraph(this.selectedDeviceId, tankName, this.chartTimeStart, this.chartTimeEnd).subscribe((response: any) => {
      if (response) {
        this.initSortChart(response.graph_data, response.min, response.max, capacityMax);
      } else {
        this.initSortChart({}, 0, 0, 0);
      }
    });
  }

  showDateControlsCsv() {
    this.showDatePicker = true;
  }
  exportToCsv(deviceId: string) {
    console.log(this.csvStart);
    this.dashboardService.exportToCsv(deviceId, this.csvStart, this.csvEnd).subscribe((response: any) => {
      window.open(response.url, '_blank');
      this.showDatePicker = false;
    });
  }

  showCoordinatesDialogView() {
    this.showCoordinatesDialog = true;
  }

  updateCoordinates(device: any) {
    this.dashboardService.updateCoordinates(device.gsmId, device.latitude, device.longitude).subscribe(() => {
      this.showCoordinatesDialog = false;
      this.lat = +device.latitude;
      this.lng = +device.longitude;
    });
  }

  enterEditDeviceDataMode() {
    if (this.password) {
      // $("#passwordmodal").modal('hide');
      this.authService.checkPasswordValidity({ 'password': this.password }).subscribe(() => {
        $('#settingsPassError').html("");
        this.modalService.dismissAll();
        $("#editmodal").modal('show');
        this.password = '';
        //this.ngxService.start();
        // const requests = [
        //   this.dashboardService.getDeviceDetails(device.gsmId),
        //   this.dashboardService.getTemplates()
        // ];
        // NOTE: Database has trouble when multiple requests go at once
        // forkJoin(requests).subscribe((response) => {
        this.dashboardService.getDeviceDetails(this.selectedDeviceForEditId).subscribe(response => {
          this.selectedDeviceForEdit = response;
          this.updateDeviceData = Object.assign({}, this.selectedDeviceForEdit.deviceSettingsData);
          this.updateDeviceData.coordinateOption === "0" ? this.isFirstChecked = true : this.isSecondChecked = true;
          this.devicePsi = this.selectedDeviceForEdit.psiData;
          if (this.devicePsi.alarmFrequency == undefined)
            this.devicePsi.alarmFrequency = '2';
          // this.ngxService.stop();
        });
      }, error => {
        this.password = '';
        $('#settingsPassError').html("Wrong password");
      });
    } else {
      $('#settingsPassError').html("Please enter your password");
    }
  }

  selectTankData(event: any, tank: string) {
    this.devicePsi['tankSize' + tank] = event;
    const tankSizeData = this.selectedDeviceForEdit.tankSizeData.find(x => x.tankType === event);
    this.updateDeviceData[`channel${tank}Capacity`] = tankSizeData['capacity'];
    this.updateDeviceData[`channel${tank}High1`] = tankSizeData['high1'];
    this.updateDeviceData[`channel${tank}High2`] = tankSizeData['high2'];
    this.updateDeviceData[`channel${tank}Low1`] = tankSizeData['low1'];
    this.updateDeviceData[`channel${tank}Low2`] = tankSizeData['low2'];
    this.updateDeviceData[`channel${tank}Min`] = tankSizeData['min'];
    this.devicePsi['width' + tank] = tankSizeData['width'];
    this.devicePsi['length' + tank] = tankSizeData['length'];

    // logic for data filling
  }
  selectChanelData(event: any, tank: string) {
    this.devicePsi[tank] = event;
  }
  selectTmData(event: any, tank: string) {
    this.devicePsi[tank] = event;
  }

  selectTemplate(templateId: string) {
    if (templateId !== '0') {
      // this.ngxService.start();
      this.dashboardService.getTemplateById(templateId).subscribe((response) => {
        // Channel 01
        this.updateDeviceData['channelA01Capacity'] = response['a01GSMLevelMax'];
        this.updateDeviceData['channelA01High1'] = response['a01GSMLevel1High'];
        this.updateDeviceData['channelA01High2'] = response['a01GSMLevel2High'];
        this.updateDeviceData['channelA01Low1'] = response['a01GSMLevel1Low'];
        this.updateDeviceData['channelA01Low2'] = response['a01GSMLevel2Low'];
        this.updateDeviceData['channelA01Min'] = response['a01GSMLevelMin'];
        // Channel 02
        this.updateDeviceData['channelA02Capacity'] = response['a02GSMLevelMax'];
        this.updateDeviceData['channelA02High1'] = response['a02GSMLevel1High'];
        this.updateDeviceData['channelA02High2'] = response['a02GSMLevel2High'];
        this.updateDeviceData['channelA02Low1'] = response['a02GSMLevel1Low'];
        this.updateDeviceData['channelA02Low2'] = response['a02GSMLevel2Low'];
        this.updateDeviceData['channelA02Min'] = response['a02GSMLevelMin'];
        // Channel 03
        this.updateDeviceData['channelA03Capacity'] = response['a03GSMLevelMax'];
        this.updateDeviceData['channelA03High1'] = response['a03GSMLevel1High'];
        this.updateDeviceData['channelA03High2'] = response['a03GSMLevel2High'];
        this.updateDeviceData['channelA03Low1'] = response['a03GSMLevel1Low'];
        this.updateDeviceData['channelA03Low2'] = response['a03GSMLevel2Low'];
        this.updateDeviceData['channelA03Min'] = response['a03GSMLevelMin'];
        // Channel 04
        this.updateDeviceData['channelA04Capacity'] = response['a04GSMLevelMax'];
        this.updateDeviceData['channelA04High1'] = response['a04GSMLevel1High'];
        this.updateDeviceData['channelA04High2'] = response['a04GSMLevel2High'];
        this.updateDeviceData['channelA04Low1'] = response['a04GSMLevel1Low'];
        this.updateDeviceData['channelA04Low2'] = response['a04GSMLevel2Low'];
        this.updateDeviceData['channelA04Min'] = response['a04GSMLevelMin'];
        //Chanel 05        
        this.updateDeviceData['deviceOffsetRate'] = response['deviceOffsetRate'];
        this.updateDeviceData['deviceOffsetRate2'] = response['deviceOffsetRate2'];
        this.updateDeviceData['deviceOffsetRate3'] = response['deviceOffsetRate3'];
        this.updateDeviceData['deviceOffsetRate4'] = response['deviceOffsetRate4'];
        // this.ngxService.stop();
      });
    }
  }

  saveDeviceDetails(modal: any) {
    $("#editmodal").modal('hide');
    this.dashboardService.updateDeviceData(this.updateDeviceData, this.selectedDeviceForEditId).subscribe(() => {
      this.dashboardService.updatePsiData(this.devicePsi, this.selectedDeviceForEditId).subscribe(() => {
      });
    });
  }

  onPasswordModal(template, device: any) {
    // $('#passwordmodal').modal('show');
    this.modalService.open(template);
    this.selectedDeviceForEditId = device.gsmId;
    this.password = '';
    document.getElementById('password').focus();
  }


  options = {};
  nodes;
  showSideMenu = false;
  sideMenuSizeClass;
  deviceSizeClass = "col-xs-12 col-sm-6 col-md-4";
  mapSizeClass = "col-12 col-sm-6 col-md-8";
  chartSizeClass = "col-md-13";
  sidemenu() {
    if (this.showSideMenu == false) {
      this.dashboardService.getTreeList().subscribe(x => {
        this.nodes = x;
        console.log(x);
        this.showSideMenu = true;
        this.sideMenuSizeClass = "col-xs-3 col-sm-2 col-md-2";
        this.deviceSizeClass = "col-xs-12 col-sm-6 col-md-4";
        this.mapSizeClass = "col-9 col-sm-8 col-md-6";
        this.chartSizeClass = "col-md-13";
        this.driverClass = "col-12 col-sm-4 col-md-6 content-wrap padding-none";
        this.vanAreaClass = "col-12 col-sm-4 col-md-6 content-wrap"
      });

    }
    else {
      this.showSideMenu = false;
      this.deviceSizeClass = "col-xs-12 col-sm-6 col-md-4";
      this.mapSizeClass = "col-12 col-sm-6 col-md-8";
      this.chartSizeClass = "col-md-13";
      this.driverClass = "col-12 col-sm-6 col-md-8 content-wrap padding-none";
      this.vanAreaClass = "col-12 col-sm-6 col-md-8 content-wrap"
    }
  }
  onEvent($event) {

    console.log('dasboard event', $event);
    console.log('child id', $event.node.data.childId);
    console.log('parent id', $event.node.data.parentId);
    console.log('company id', $event.node.data.companyId);

    this.ngxService.start();
    var sub = this.dashboardService.getUserDevices($event.node.data.companyId, $event.node.data.parentId, $event.node.data.childId).subscribe((response: any) => {
      if (response != null) {
        this.userDevicesFiltered = response;
        this.userDevices = response;
        let firstDevice = this.userDevicesFiltered[0];

        if (!this.isMobile) {
          this.initChart({}, 0, 0, 0);
        }
        this.selectedDevice = null;
        this.applyTableControls();

        if (response.length != 0) {
          this.selectDevice(firstDevice);
          this.selectedGSM = firstDevice.gsmId;
        }
        else {
          this.selectDevice(null);
          this.selectedGSM = "";
        }
      }
      sub.unsubscribe();
      this.ngxService.stop();
    });
  }

  onEditDescModal(device: any) {

    this.selectedDeviceForEditId = device.gsmId;
    if (this.showDescriptionEdit === false) {
      //console.log(device)
      $("#deviceIdDesc").text(device.gsmId);
      $("#deviceNameDesc").text(device.gsmName);
      $('#passwordmodalxx').modal('show');
      if (device.deviceDescription === "") {
        $("#descForm").find('textarea').val(device.deviceDescription)
        $("#descForm").find('textarea').attr("placeholder", "Add description to this device..");
      } else {
        $("#descForm").find('textarea').val(device.deviceDescription)
      }
      //console.log("ss");
      this.showDescriptionEdit = false;
      document.getElementById('passwordxx').focus();
    } else {
      this.showDescriptionEdit = false;
    }

    /*
    this.selectedDeviceForEditId = device.gsmId;

    if (this.showDescriptionEdit === false) {
      $('#editDescModal').toggle();
      $("#deviceIdDesc").text(device.gsmId);
      $("#passwordmodalxx").text(device.gsmName);
      if(device.deviceDescription === "") {
        $("#descForm").find('textarea').val(device.deviceDescription)
        $("#descForm").find('textarea').attr("placeholder", "Add description to this device..");
      } else {
        $("#descForm").find('textarea').val(device.deviceDescription)
      }
      console.log("ss");
      this.showDescriptionEdit = true;
      document.getElementById('descForm').focus();
    } else {
      $('#editDescModal').toggle();
      this.showDescriptionEdit = false;
    }
    */
  }

  hideDescriptionEdit() {
    $('#editDescModal').toggle();
    this.showDescriptionEdit = false;
  }

  showSortedGroup(groupId: number) {
    // var selectedGroup = $("[data-devicegroup='" + groupId + "']");
    // $('.table-sort-item').hide();
    // $('.sort-custom-select').find('option').attr('selected', false);
    // $('.sort-custom-select').find('option[value='+groupId+']').attr('selected', true);
    // $(selectedGroup).show();
    var activeElements = document.getElementsByClassName('active');
    if (activeElements.length !== 0)
      activeElements.item(0).classList.remove("active");
    var element = document.getElementById('group' + groupId);
    element.classList.add("active");
    this.userDevicesFiltered = this.userDevices;
    this.filterByGroup = groupId.toString();
    this.applyTableControls();
  }



  updateDeviceDescription() {
    var deviceId = $('#deviceIdDesc').text();
    var deviceDesc = $("#descForm").find('textarea').val();
    this.dashboardService.updateDeviceDescription(deviceId, deviceDesc).subscribe(() => {
      this.changingNameId = '';
    })
    $('#passwordmodalxx').modal('hide');
  }



  deviceGroupChange(deviceGroupValue, deviceId) {
    console.log(deviceGroupValue + ' ' + deviceId);
    // call sp_device_group_update (deviceId, deviceGroupValue);
    this.dashboardService.updateDeviceGroup(deviceId, deviceGroupValue).subscribe(() => {
      this.changingNameId = '';
    })
  }

  onSortModal() {
    let findActiveGroup = document.getElementsByClassName("active");
    if (findActiveGroup.length !== 0) {
      this.showSortedGroup(parseInt(findActiveGroup.item(0).id.substring(5)));
    }
    else {
      this.showSortedGroup(1);
    }
    $('#sortmodal').modal('show');
  }


  latLongChbEvent(event: any, position: string) {
    if (position == 'first') {
      if (event == true) {
        this.isSecondChecked = false;
        this.updateDeviceData['coordinateOption'] = "0";
      }
      else {
        this.isSecondChecked = true;
      }
    }
    if (position == 'second') {
      if (event == true) {
        this.isFirstChecked = false;
        this.updateDeviceData['coordinateOption'] = "1";
      }
      else {
        this.isFirstChecked = true;
      }
    }
  }

  // Mobile
  showDashboard() {
    if (this.isMobile) {
      this.showSingleView = false;
      this.showMapView = false;
    }
  }

  showSingle() {
    this.showSingleView = true;
    this.showMapView = false;
  }


  showMap() {
    if (this.isMobile) {
      if (this.showSingleView) {
        if (this.selectedDevice.latitude === null || this.selectedDevice.longitude === null) {
          this.showCenter = true;
        } else {
          this.lat = +this.selectedDevice.latitude;
          this.lng = +this.selectedDevice.longitude;
          this.showCenter = false;
        }
      } else {
        this.onDeviceMapChange()
      }
      this.showSingleView = false;
      this.showMapView = true;
    }
  }

  initSortMobile() {
    if (this.sortId) {
      (<any>document.getElementById(this.sortId)).checked = true;
    }
  }

  initFilterMobile() {
    if (this.filterId) {
      (<any>document.getElementById(this.filterId)).checked = true;
    }
  }



  private initChart(graphData: any, min: number, max: number, capacityMax) {
    var data = [];

    for (const prop in graphData) {
      if (graphData.hasOwnProperty(prop)) {
        data.push({
          date: new Date(prop),
          name: "name" + graphData[prop].value,
          value: graphData[prop].value,
          maximum: max
        });
      }
    }


    const chartId = window.screen.width < 768 ? 'chartdivsm' : 'chartdiv';

    // Create chart
    am4core.createFromConfig({
      // Set settings and data
      "paddingRight": 15,
      "data": data,

      // Create X axes
      "xAxes": [{
        "type": "DateAxis",
        "tooltipDateFormat": "d MMMM yyyy, HH:mm",
        "renderer": {
          "grid": {
            "location": 0
          }
        }
      }],

      // Create Y axes
      "yAxes": [{
        "type": "ValueAxis",
        "min": 0,
        "tooltip": {
          "disabled": true
        },
        "renderer": {
          "minWidth": 35
        }
      }],

      // Create series
      "series": [{
        "id": "s1",
        "fillOpacity": 0.4,
        "type": "LineSeries",
        "dataFields": {
          "dateX": "date",
          "valueY": "value"
        },
        "tooltipText": "{valueY.value}"
      },
      {
        "type": "LineSeries",
        "stroke": "#CDA2AB",
        "strokeWidth": 3,
        "dataFields": {
          "dateX": "date",
          "valueY": "maximum"
        },
        "name": "Max"
      }],
      "guides": [
        {
          "fillAlpha": 0.10,
          "value": 0,
          "toValue": 10000
        }
      ],
      // Add cursor
      "cursor": {
        "type": "XYCursor"
      },
      // Add horizontal scrollbar
      "scrollbarX": {
        "type": "XYChartScrollbar",
        "series": ["s1"]
      }
    }, chartId, 'XYChart');
  }

  private initSortChart(graphData: any, min: number, max: number, capacityMax) {
    var data = [];

    for (const prop in graphData) {
      if (graphData.hasOwnProperty(prop)) {
        data.push({
          date: new Date(prop),
          name: "name" + graphData[prop].value,
          value: graphData[prop].value,
          maximum: max
        });
      }
    }

    const sortChartId = window.screen.width < 768 ? 'sortChartdivsm' : 'sortChartdiv';

    // Create chart
    am4core.createFromConfig({
      // Set settings and data
      "paddingRight": 15,
      "data": data,

      // Create X axes
      "xAxes": [{
        "type": "DateAxis",
        "tooltipDateFormat": "d MMMM yyyy, HH:mm",
        "renderer": {
          "grid": {
            "location": 0
          }
        }
      }],

      // Create Y axes
      "yAxes": [{
        "type": "ValueAxis",
        "min": 0,
        "tooltip": {
          "disabled": true
        },
        "renderer": {
          "minWidth": 35
        }
      }],

      // Create series
      "series": [{
        "id": "s1",
        "fillOpacity": 0.4,
        "type": "LineSeries",
        "dataFields": {
          "dateX": "date",
          "valueY": "value"
        },
        "tooltipText": "{valueY.value}"
      },
      {
        "type": "LineSeries",
        "stroke": "#CDA2AB",
        "strokeWidth": 3,
        "dataFields": {
          "dateX": "date",
          "valueY": "maximum"
        },
        "name": "Max"
      }],
      "guides": [
        {
          "fillAlpha": 0.10,
          "value": 0,
          "toValue": 10000
        }
      ],
      // Add cursor
      "cursor": {
        "type": "XYCursor"
      },
      // Add horizontal scrollbar
      "scrollbarX": {
        "type": "XYChartScrollbar",
        "series": ["s1"]
      }
    }, sortChartId, 'XYChart');
  }



  private generateTimezoneModel() {
    for (let i = -12; i <= 14; i++) {
      const value = i > 0 ? '+' + i + ':00' : i + ':00';
      this.timezones.push({ label: 'UTC' + value, value: 'UTC' + value });
    }
  }

  //KAMIONI
  tableHeaders = [{ displayName: "Tank Id", name: "gsmId", width: 80 }, { displayName: "Tank Name", name: "gsmName", width: 100 },
  { displayName: "Product", name: "product", width: 100 }, { displayName: "Capacity", name: "capacity", width: 100 },
  { displayName: "Ullage", name: "ullage", width: 75 }, { displayName: "Required", name: "required", width: 100 },
  { displayName: "Action", name: "action", width: 60 }]

  // driverRecords = [
  //   { "tankId": "1", "tankName": "1", "product": "1", "capacity": "321", "ullage": "64", "required": "341", "action": "" },
  //   { "tankId": "1", "tankName": "11", "product": "2", "capacity": "235", "ullage": "341", "required": "", "action": "" },
  //   { "tankId": "1", "tankName": "213", "product": "3", "capacity": "643", "ullage": "34", "required": "", "action": "" },
  //   { "tankId": "1", "tankName": "414", "product": "4", "capacity": "6431", "ullage": "6431", "required": "6431", "action": "" },
  // ]

  driverRecords = [];
  header: HeaderModel = new HeaderModel();
  vanArea: boolean = false;
  tankArea: boolean = true;
  displayVan() {
    if (this.vanArea == true) {
      this.header.driver = null;
      this.header.date = "";
      this.header.driverId = "";
      this.header.note = "";
      this.header.truckType = "";
      this.activeHeader = "";
      this.driverRecords = [];
      this.vanArea = false;
      this.tankArea = true;
      this.tankDisplay = true;
      this.vanAreaClass = "col-12 col-sm-6 col-md-8 content-wrap";
    }
    else {
      this.getAllDrivers();
      this.vanArea = true;
      this.tankArea = false;
    }
  }

  truckTypes: string[] = ['small', 'mid', 'big']
  drivers: any;
  getAllDrivers() {
    var sub = this.dashboardService.getAllDrivers(this.loggedUser).pipe(
      tap(res => {
        this.drivers = res;
        console.log(res);
      }),
      finalize(() => sub.unsubscribe())
    ).subscribe();
  }
  driver: DriverModel;
  driverModalTitle: string;
  driverSaveAction: string;
  isDriverNeedSave: boolean = false;
  openDriverModal(content, action) {
    if (this.header.driver != null) {
      if (action == 'info') {
        this.driver = this.drivers.find(x => x.id == this.header.driver.id);
        this.driverSaveAction = "update";
        this.driverModalTitle = "Update driver";
        this.modalService.open(content);
      }
    }
    if (action == 'new') {
      this.driver = new DriverModel();
      this.driver.id = null;
      this.driverSaveAction = "create";
      this.driverModalTitle = "Create new driver";
      this.modalService.open(content);
    }
  }

  saveDriver(driver: DriverModel) {
    if (driver.id != null) {
      var sub = this.dashboardService.updateDriver(driver).pipe(
        tap(),
        finalize(() => sub.unsubscribe())
      ).subscribe();
    }
    else {
      var subDriver = this.dashboardService.createDriver(this.loggedUser, driver).pipe(
        tap(s => {
          this.getAllDrivers();
        }),
        finalize(() => subDriver.unsubscribe())
      ).subscribe();
    }
    this.modalService.dismissAll();
  }

  headerList = [];
  addDeviceToTable() {
    if (this.header.driver && this.header.date && this.activeHeader) {
      this.ConvertDriverRecordToJson(this.deviceRecord.valueA01, this.deviceRecord, "1", this.deviceRecord.capacityA01Max, this.deviceRecord.ullageA01, 0);
      this.ConvertDriverRecordToJson(this.deviceRecord.valueA02, this.deviceRecord, "2", this.deviceRecord.capacityA02Max, this.deviceRecord.ullageA02, 0);
      this.ConvertDriverRecordToJson(this.deviceRecord.valueA03, this.deviceRecord, "3", this.deviceRecord.capacityA03Max, this.deviceRecord.ullageA03, 0);
      this.ConvertDriverRecordToJson(this.deviceRecord.valueA04, this.deviceRecord, "4", this.deviceRecord.capacityA04Max, this.deviceRecord.ullageA04, 0);
      var sub = this.dashboardService.createHeaderRecord(this.headerList, this.activeHeader).pipe(
        tap(r => {
          this.headerList = [];
          this.driverRecords = r;
        }),
        finalize(() => sub.unsubscribe())
      ).subscribe();
      return false;
    }
    return true;
  }

  private ConvertDriverRecordToJson(currentLevel: number, device: any, productId: string, capacity: string, ullage: string, required: number) {
    if (currentLevel != 0 && this.header.driver != null && this.header.date != null) {
      var product = new DriverTableRecord();
      product.product = productId
      product.gsmId = device.gsmId;
      product.gsmName = device.gsmName;
      product.capacity = capacity;
      product.ullage = ullage;
      product.required = required;
      product.action = "";
      if (this.activeHeader) {
        product.headerId = this.activeHeader;
      }
      this.headerList.push(product);

    }
  }

  dates = [];
  driverSelect(driverId: string) {
    this.header.truckType = "";
    this.header.note = "";
    this.header.date = "";
    this.activeHeader = "";
    this.driverRecords = [];
    var sub = this.dashboardService.getDates(driverId).pipe(
      tap(r => {
        this.dates = r;
        if (this.dates.length == 0)
          this.isDriverNeedSave = true;
      }),
      finalize(() => sub.unsubscribe())
    ).subscribe();
  }

  changeDate(date: string, driverId: string) {
    this.driverRecords = [];
    var checksub = this.dashboardService.checkHeadersByDate(date, driverId).pipe(
      tap(r => {
        if (r.length) {
          this.activeHeader = r[0].headerId;
          this.driverRecords = r;
        }
        else {
          this.activeHeader = r;
        }
      }),
      finalize(() => checksub.unsubscribe())
    ).subscribe();

    var areasub = this.dashboardService.getAreaDetails(date, driverId).pipe(
      tap(r => {
        this.header.truckType = r.truckType;
        this.header.note = r.note;
      }),
      finalize(() => areasub.unsubscribe())
    ).subscribe();
  }

  activeHeader: string;

  saveDriverHeader(header: HeaderModel) {
    header.driverId = header.driver.id;
    var sub = this.dashboardService.saveDriverHeader(header).pipe(
      tap(r => {
        this.activeHeader = r;
        this.isDriverNeedSave = false;
      }),
      finalize(() => sub.unsubscribe())
    ).subscribe();
  }

  deleteRecord(header: any) {
    if (confirm("Are you sure ?")) {
      this.driverRecords = [];
      var sub = this.dashboardService.deleteHeaderRecord(header).pipe(
        tap(r => {
          this.driverRecords = r;
        }),
        finalize(() => sub.unsubscribe())
      ).subscribe();
    }
  }

  updateRecord(header: any) {
    this.driverRecords = [];
    var sub = this.dashboardService.updateHeaderRecord(header).pipe(
      tap(r => {
        this.driverRecords = r;
      }),
      finalize(() => sub.unsubscribe())
    ).subscribe();
  }

  selectedDate(date: any) {
    date.month = date.month - 1;
    var formatedDate = moment(date).format("YYYY-MM-DD")
    this.isDriverNeedSave = true;
    this.header.note = "";
    this.header.truckType = "";
    this.driverRecords = [];
    this.header.date = formatedDate;
    this.dates.push(formatedDate);
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: Event): void {
    this.menuState = false;
  }
  @HostListener('document:contextmenu', ['$event'])
  public documentRClick(event: Event): void {
    this.menuState = false;
  }


  getPosition(e) {
    var posx = 0;
    var posy = 0;
    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx = e.clientX + document.body.scrollLeft +
        document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop +
        document.documentElement.scrollTop;
    }
    return { x: posx, y: posy }
  }

  menuPosition;
  menuPositionX;
  menuPositionY;
  menuWidth;
  windowWidth;
  windowHeight;
  menuHeight;
  positionMenu(e) {
    this.menuPosition = this.getPosition(e);
    this.menuPositionX = this.menuPosition.x;
    this.menuPositionY = this.menuPosition.y;
    this.cdRef.detectChanges();
    this.menuWidth = 106;
    this.menuHeight = 30;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    if ((this.windowWidth - this.menuPositionX) < this.menuWidth) {
      this.menuPositionX = this.windowWidth - this.menuWidth + "px";
    } else {
      this.menuPositionX = this.menuPositionX + "px";
    }
    if ((this.windowHeight - this.menuPositionY) < this.menuHeight) {
      this.menuPositionY = this.windowHeight - this.menuHeight + "px";
    } else {
      this.menuPositionY = this.menuPositionY + "px";
    }
  }

  menuState = false;
  deviceRecord: any;
  onRightClick(event, data) {
    if (this.header.driver && this.header.date && this.activeHeader) {
      this.deviceRecord = data;
      event.stopPropagation();
      this.menuState = true;
      this.positionMenu(event);
    }
  }
  tankDisplay: boolean = true;
  truckMap: boolean = false;
  driverClass = "col-12 col-sm-6 col-md-8 content-wrap padding-none";
  truckMapClass;
  vanAreaClass = "col-12 col-sm-6 col-md-8 content-wrap"
  tableHeight = "truck-table-height-full";
  showTruckMap() {
    if (this.tankDisplay == true) {
      this.tankDisplay = false;
      this.vanAreaClass = "col-xs-12 col-sm-6 col-md-4 content-wrap background-white padding-top-fix display-table device-list-holder";
      this.truckMap = true;
      this.truckMapClass = "col-12 col-sm-6 col-md-8 content-wrap";
      this.tableHeight = "truck-table-height-left-side";

    }
    else {
      this.truckMap = false;
      this.tankDisplay = true;
      this.vanAreaClass = "col-12 col-sm-6 col-md-8 content-wrap";
      this.tableHeight = "truck-table-height-full";
    }
  }

  fuelButtons = [];
  loadingFuels : boolean = true;
  getFuelBids(deviceId:string){
    this.fuelButtons = [];
    this.loadingFuels = true;
    var sub= this.dashboardService.getFuelBids(deviceId)
    .pipe(
      take(1),
      map(x => this.fuelButtons = x),
      finalize(() => this.loadingFuels = false ),
      finalize(() => sub.unsubscribe() )
      ).subscribe();
  }

  fuelModel : FuelBid = new FuelBid();
  openFuelModal(content ,value, deviceId){
    this.ngxService.start();
    var locSub= this.dashboardService.getFuelLocation(deviceId).pipe(
      take(1),
      tap(x => {
        if(x.latitude != ''){
          this.fuelModel.location = x.mapUrl;
        }
        else{
          this.fuelModel.location = '';
        }
        this.fuelModel.gsmId = deviceId;
        this.fuelModel.product = value;
        this.modalService.open(content);
        this.ngxService.stop();
      }),
      finalize(() => locSub.unsubscribe())
    ).subscribe();
  }

  emailValidator: any;
  nameValidator:any;
  dateValidator:any;
  sendMail(model: FuelBid){
    if(!model.name){
      this.nameValidator = "Please enter your name !";
      return ;
    }
    else{
      this.nameValidator = null;
    }
    if(!model.email){
      this.emailValidator = "Please enter your email !";
      return ;
    }
    else{
      this.emailValidator = null;
    }

    if(!model.dateRequired){
      this.dateValidator = "Please enter required date !";
      return ;
    }
    else{
      this.dateValidator = null;
    }
    var test = re.test(model.email);
    if(!re.test(model.email)){
      this.emailValidator = "Email address is not valid !";
      return ;
    }

    this.ngxService.start();
    var sub = this.dashboardService.sendFuelMail(model).pipe(
      take(1),
      first(),
      finalize(() => {
        this.ngxService.stop();
        this.fuelModel= new FuelBid();
        this.modalService.dismissAll();

      } ), 
      finalize(() => sub.unsubscribe())).subscribe();
  }

}




